import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { License } from '@compiere-ws/models/license';
import { AppConfig } from '@iupics-config/app.config.service';
import { Observable, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LicenseService {
  #config = inject(AppConfig);
  #api = inject(HttpClient);

  license$: Observable<License> | undefined;

  get(): Observable<License> {
    if (this.license$ === undefined) {
      this.license$ = this.#api.get<License>(this.#config.getBackendResource('license')).pipe(
        shareReplay({
          bufferSize: 1,
          refCount: true,
        })
      );
    }
    return this.license$;
  }

  resetCachingData(): void {
    this.license$ = undefined;
  }
}
